import { faCommentQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chatbot } from 'components/chatbot/Chatbot';
import { HelpMenu } from 'components/help_menu/HelpMenu';
import { NavigationItemExpandButton } from 'components/navigation_drawer/NavigationItemExpandButton';
import { useNavigationDrawerValues } from 'components/navigation_drawer/navigation_drawer_store';
import {
    NavigationChatbotIcon,
    NavigationDrawerFooterWrapper,
    NavigationFooterContent,
    NavigationFooterHeader,
    NavigationFooterIcon,
    NavigationFooterItems,
    NavigationItemAccordion,
    NavigationItemTitle,
} from 'components/navigation_drawer/styled';

export function NavigationDrawerFooter() {
    const {
        isDrawerExpanded,
        isFooterExpanded,
        isChatbotOpen,
        toggleDrawerExpanded,
        toggleFooterExpanded,
        toggleChatbotOpen,
    } = useNavigationDrawerValues((state) => ({
        isDrawerExpanded: state.isDrawerExpanded,
        isFooterExpanded: state.isFooterExpanded,
        isChatbotOpen: state.isChatbotOpen,
        toggleDrawerExpanded: state.toggleDrawerExpanded,
        toggleFooterExpanded: state.toggleFooterExpanded,
        toggleChatbotOpen: state.toggleChatbotOpen,
    }));

    return (
        <NavigationDrawerFooterWrapper $expanded={isDrawerExpanded}>
            {isDrawerExpanded ? (
                <NavigationFooterContent>
                    <NavigationChatbotIcon $expanded onClick={toggleChatbotOpen}>
                        <FontAwesomeIcon icon={faCommentQuestion} size="lg" />
                        <NavigationItemTitle>KCFchat</NavigationItemTitle>
                    </NavigationChatbotIcon>
                    <NavigationItemAccordion>
                        <NavigationFooterHeader onClick={toggleFooterExpanded}>
                            <NavigationFooterIcon $expanded />
                            <NavigationItemExpandButton
                                expandType="upward"
                                expanded={isFooterExpanded}
                            />
                        </NavigationFooterHeader>
                        <NavigationFooterItems $show={isFooterExpanded}>
                            <HelpMenu />
                        </NavigationFooterItems>
                    </NavigationItemAccordion>
                </NavigationFooterContent>
            ) : (
                <NavigationFooterContent>
                    <NavigationChatbotIcon
                        $expanded={false}
                        onClick={() => {
                            toggleChatbotOpen();
                        }}
                    >
                        <FontAwesomeIcon icon={faCommentQuestion} size="lg" />
                    </NavigationChatbotIcon>
                    <NavigationFooterIcon
                        $expanded={false}
                        onClick={() => {
                            toggleDrawerExpanded();
                            toggleFooterExpanded();
                        }}
                    />
                </NavigationFooterContent>
            )}
            {isChatbotOpen && (
                <Chatbot
                    isFooterExpanded={isFooterExpanded}
                    isDrawerExpanded={isDrawerExpanded}
                    onClose={toggleChatbotOpen}
                />
            )}
        </NavigationDrawerFooterWrapper>
    );
}
